'use client'

import { useServerInsertedHTML } from 'next/navigation'

// Idempotent FOUC guard. next-themes' own <script> is disabled (see
// theme-provider.tsx) because React 19.3 errors when a Client Component
// renders an executable <script>. useServerInsertedHTML puts this IIFE
// into the SSR HTML stream without owning it on the client.
const THEME_BOOTSTRAP_SCRIPT = `(function(){try{var stored=localStorage.getItem('theme');var theme=stored||'system';var resolved=theme==='system'?(window.matchMedia('(prefers-color-scheme: dark)').matches?'dark':'light'):theme;var root=document.documentElement;root.classList.remove('light','dark');root.classList.add(resolved);if(resolved==='light'||resolved==='dark')root.style.colorScheme=resolved}catch(e){}})();`

export function ThemeBootstrap() {
  useServerInsertedHTML(() => (
    <script
      id="theme-bootstrap"
      dangerouslySetInnerHTML={{ __html: THEME_BOOTSTRAP_SCRIPT }}
    />
  ))

  return null
}
